import { useCommon } from '@/core/useCommon'
import { useEffect } from 'react'
import { useForm, UseFormReturn } from 'react-hook-form'

type UseFormTriggerProps = {
  form: UseFormReturn<any>
}

// 讓 form 已出現後再切語系時可以再次觸發驗證(改成新的語系)
export const useFormTrigger = ({ form }: UseFormTriggerProps) => {
  const { t } = useCommon()

  useEffect(() => {
    if (!Object.keys(form?.formState?.errors).length) return
    form.trigger()
  }, [t])

  return null
}
